import { ChangeDetectionStrategy, Component, computed, effect, inject, input, untracked } from '@angular/core';

import { AvatarService } from '@core/services/avatar.service';

import { SvgIcon } from '@shared/components/svg-icon/svg-icon';

import { AVATAR_ICON_SIZE, AVATAR_SIZE_CLASS, AVATAR_TEXT_CLASS, type AvatarConfig } from './avatar.types';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.html',
  imports: [SvgIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Avatar {
  private readonly avatarService = inject(AvatarService);

  readonly config = input.required<AvatarConfig>();

  protected readonly sizeClass = AVATAR_SIZE_CLASS;
  protected readonly iconSize = AVATAR_ICON_SIZE;
  protected readonly textClass = AVATAR_TEXT_CLASS;

  protected readonly resolvedImageUrl = computed(() => {
    const config = this.config();
    if (config.profileId) {
      const avatars = this.avatarService.avatars();
      const cached = avatars.find((avatar) => avatar.id === config.profileId);
      if (cached?.url) return cached.url;
    }
    return config.imageUrl;
  });

  constructor() {
    effect(() => {
      const { profileId, hasPhoto } = this.config();
      if (profileId) {
        untracked(() => this.avatarService.getAvatarUrl(profileId, !!hasPhoto).catch(console.error));
      }
    });
  }
}
